export default "__VITE_PUBLIC_ASSET__fb85b6ce__"